import React from "react";

const NotFound = () => (
  <div>
    <h3>Sorry, your page cannot be found at the moment</h3>
  </div>
);
export default NotFound;
